export default {
    all: { method: 'GET', url: 'cliente-fornecedor/all' },
    active: { method: 'GET', url: 'cliente-fornecedor/active' },
    get: { method: 'GET', url: 'cliente-fornecedor/get{/id}{/tipo}' },
    create: { method: 'POST', url: 'cliente-fornecedor' },
    update: { method: 'PUT', url: 'cliente-fornecedor' },
    inactive: { method: 'DELETE', url: 'cliente-fornecedor{/id}{/tipo}' },
};